import React, { useRef, useEffect } from 'react';
import { Form, Input, DatePicker, Checkbox } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import cloneDeep from 'lodash/cloneDeep';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

function CampusExperience(props) {
  const formRefs = useRef<any[]>([]);
  const { type, data } = props;
  const { campusResumeDetail, campusResumeFormRefStore } = useRootStore();
  let store;
  let storeRef;
  if (type === 'campus') {
    store = campusResumeDetail;
    storeRef = campusResumeFormRefStore;
  }

  useEffect(() => {
    storeRef.changeRef('resumeCampusExpListRef', formRefs.current);
    const cloneData = cloneDeep(data);
    cloneData?.map((item, index) => {
      formRefs.current[index]?.setFieldsValue({
        endDate: item.endDate === 253370736000000 ? 0 : item.endDate,
      });
      return null;
    });
  }, [data, data?.length]);

  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    store.setResumeCampusExpList(index, formItemKey, formItemValue);
  };

  return (
    <div className="campus_experience_edit model_edit">
      <div className="model_title">校园经历</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem
              formItemKey="experienceName"
              span="11"
              labelWidth={0}
              required
              message="请填写校园经历名称"
              rules={[
                {
                  required: true,
                  message: '请填写校园经历名称',
                },
                {
                  type: 'string',
                  max: 100,
                  message: '校园经历名称不能超过100字',
                },
              ]}
            >
              <div className="label">
                校园经历名称<span className="icon">*</span>
              </div>
              <Input toFormItem size="large" placeholder="请输入校园经历名称" maxLength={100} />
            </FormItem>
            <FormItem
              formItemKey="role"
              span="11"
              labelWidth={0}
              required
              message="请填写角色名称"
              rules={[
                {
                  required: true,
                  message: '请填写角色名称',
                },
                {
                  type: 'string',
                  max: 100,
                  message: '角色不能超过100字',
                },
              ]}
            >
              <div className="label">
                角色 <span className="icon">*</span>
              </div>

              <Input toFormItem size="large" placeholder="请输入角色" maxLength={100} />
            </FormItem>
            <FormItem
              className="form_item_start_date"
              formItemKey="startDate"
              span="4"
              labelWidth={0}
              required
              message="请填写开始时间"
            >
              <div className="label">
                校园经历时间<span className="icon">*</span>
              </div>
              <DatePicker
                toFormItem
                size="large"
                format="YYYY/MM"
                valueFormat="timestamp"
                placeholder="开始时间"
                disabledDate={(cur) => {
                  if (item?.endDate) return cur > item.endDate;
                  return false;
                }}
              />
              <div className="inner-line" />
            </FormItem>
            <FormItem
              className="form_item_end_date"
              formItemKey="endDate"
              span="3"
              labelWidth={0}
              required
              message="请填写结束时间"
            >
              <div className="label"> </div>
              <DatePicker
                disabled={store.resumeCampusExpList[index].endDate === 253370736000000}
                toFormItem
                size="large"
                format="YYYY/MM"
                valueFormat="timestamp"
                placeholder="结束时间"
                disabledDate={(cur) => {
                  if (item?.startDate) return cur < item.startDate;
                  return false;
                }}
              />
            </FormItem>

            <FormItem className="form_item_up_to_now" formItemKey="upToNow" span="1" labelWidth={0}>
              <div className="label"> </div>
              <Checkbox
                checked={store.resumeCampusExpList[index].endDate === 253370736000000}
                onChange={(e) => {
                  if (e.target.checked) {
                    store.setResumeCampusExpList(index, 'endDate', 253370736000000);
                    formRefs.current[index]?.setFieldsValue({ endDate: 0 });
                    formRefs.current[index]?.validateFields(['endDate']);
                  } else {
                    store.setResumeCampusExpList(index, 'endDate', '');
                    formRefs.current[index]?.setFieldsValue({ endDate: '' });
                  }
                }}
              >
                至今
              </Checkbox>
            </FormItem>
            <FormItem formItemKey="experienceDescription" span="11" labelWidth={0}>
              <div className="label">校园经历描述</div>
              <Input.TextArea
                className="input_text_area"
                toFormItem
                placeholder="请输入校园经历描述"
                showCount
                maxLength={2000}
                autosize={{ minRows: 2, maxRows: 6 }}
              />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeCampusExpList', index)}>删除这段经历</div>
          </div>
        </div>
      ))}
      <div className="list_add" onClick={() => store.addResumeList('resumeCampusExpList')}>
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加校园经历
      </div>
    </div>
  );
}

export default ModuleView(observer(CampusExperience), 'campusExperience');
